import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2> Not Found 404</h2>
        </div>
    );
};

export default NotFound;